import { createApp, h, provide } from "vue";
import pinia from "./libs/pinia";
import { DefaultApolloClient } from "@vue/apollo-composable";
import axios from "axios";
import Maska from "maska";

import App from "./App.vue";
import router from "./router";
import { apolloClient } from "./libs/apollo";
import VueGtag from "vue-gtag";
import { apiUrl, loadCordovaScript } from "./libs/environment";
// import filters from './libs/filters'

loadCordovaScript();
axios.defaults.baseURL = `${apiUrl}/`;

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
    // provide('$filters', filters)
  },
  render: () => h(App),
});

app.use(VueGtag, {
  config: { id: "G-27SNC9T54E" },
});
app.use(pinia);
app.use(router);
app.use(Maska);

app.mount("#app");
